import swiperPropertyItem from "./swipers/swiperPropertyItem";
import swiperPropertyQuickView from "./swipers/swiperPropertyQuickView";
import swiperPropertySingle from "./swipers/swiperPropertySingle";
import swiperPropertyListing from "./swipers/swiperPropertyListing";
import swiperBlockSlider from "./swipers/swiperBlockSlider";
import swiperBlockSliderCustom from "./swipers/swiperBlockSliderCustom";
import swiperBlockSliderTextOverlay from "./swipers/swiperBlockSliderTextOverlay";
import swiperTestimonials from "./swipers/swiperTestimonials";
import swiperMapLinks from "./swipers/swiperMapLinks";
import swiperImageRolloverSlider from "./swipers/swiperImageRolloverSlider";
import swiperPropertyGalleryGrid from "./swipers/swiperPropertyGalleryGrid";

export default function initSwipers() {
    swiperPropertyItem();
    swiperPropertyQuickView();
    swiperPropertySingle();
    swiperPropertyListing();
    swiperBlockSlider();
    swiperBlockSliderTextOverlay();
    swiperBlockSliderCustom();
    swiperTestimonials();
    swiperMapLinks();
    swiperImageRolloverSlider();
    swiperPropertyGalleryGrid();
}
